
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/[match]",
      function () {
        return require("private-next-pages/compare/[match].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/[match]"])
      });
    }
  